import { render, staticRenderFns } from "./PaymentForDistribution.vue?vue&type=template&id=53fe6588"
import script from "./PaymentForDistribution.js?vue&type=script&lang=js&external"
export * from "./PaymentForDistribution.js?vue&type=script&lang=js&external"
import style0 from "./PaymentForDistribution.vue?vue&type=style&index=0&id=53fe6588&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports